export const formatDate = (date) => {
  const dateParts = date.match(/\d+/g);

  const year = dateParts[0].substring(2);
  const month = dateParts[1];
  const day = dateParts[2];

  return `${day}/${month}/${year}`;
};
